<template>
    <v-form
            v-model="valid"
            ref="notificationform"
            lazy-validation
            @submit.prevent="onSubmit"
            @keyup.native.enter="onSubmit"
    >
        <v-card
                :loading="loading"
                :disabled="loading"
        >
            <v-card-title>
                Notification settings
            </v-card-title>

            <v-card-text>

                <v-text-field
                        v-model="values.api"
                        label="API Key Mailgun"
                        :disabled="loading"
                        :rules="[rules.required]"
                        outlined
                ></v-text-field>

                <v-text-field
                        v-model="values.from"
                        label="Email from"
                        hint="Enter email address - name@yourdomain.com. If you don’t use such type of a email, leave no-reply@yourdomain.com set by default."
                        persistent-hint
                        :rules="rules.emailRules"
                        outlined
                ></v-text-field>

                <v-text-field
                        v-model="values.name"
                        label="Name from"
                        :rules="[rules.required]"
                        outlined
                ></v-text-field>

                <v-text-field
                        v-model="values.domain"
                        label="Domain"
                        hint="Domain Mailgun."
                        persistent-hint
                        :rules="[rules.required]"
                        outlined
                ></v-text-field>

            </v-card-text>

            <v-card-actions class="px-4 pb-5">

                <v-btn
                        :loading="loading"
                        :disabled="loading"
                        @click="test"
                >
                    Send test
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                        color="success"
                        :loading="loading"
                        :disabled="loading"
                        type="submit"
                >
                    Save
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-form>
</template>
<script>
    export default {
        name: 'OptionsNotifications',
        data(){
            return {
                loading: false,

                rules      : {
                    required : value => !!value || 'Required field.',
                    emailRules: [
                        (v) => !!v || 'Email is required',
                        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'
                    ],
                },

                valid: false,
                values: {
                    api    : '',
                    from   : '',
                    name   : '',
                    domain : '',
                }
            }
        },
        created(){
            this.get();
        },
        methods: {
            get() {
                this.loading = true;

                this.axios.post('options/notification', JSON.stringify({
                    method: 'show'
                }))
                .then((response) => {

                    const params = response.data;

                    if (params.status === 'success') {

                        this.values = params.data.values;
                        this.loading = false;
                    } else {
                        this.$emit('alert', {type: 'error', message: params.message});
                    }
                }).catch((reject) => {
                    this.$emit('alert', {type: 'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                })
            },

            onSubmit(){
                if( this.$refs.notificationform.validate() ) {
                    this.save();
                }
            },
            save(){

                this.loading = true;

                this.axios.post( 'options/notification', JSON.stringify( {
                    method: 'edit',
                    data: this.values
                } ) ).then( (response) => {

                    let params = response.data;

                    if( params.status === 'success' ) {
                        this.$emit('alert', {type: 'success', message: params.message});
                    }else {
                        this.$emit('alert', {type: 'error', message: params.message});
                    }
                    this.loading = false;

                } ).catch( (reject) => {
                    this.$emit('alert', {type: 'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                } );
            },

            test(){

                this.loading = false;

                this.axios.post( 'options/notification', JSON.stringify( {
                    method: 'test',
                } ) ).then( (response) => {

                    let params = response.data;

                    if( params.status === 'success' ) {
                        this.$emit('alert', {type: 'success', message: params.message});
                    } else {
                        this.$emit('alert', {type: 'error', message: params.message});
                    }
                    this.loading = false;

                } ).catch( (reject) => {
                    this.$emit('alert', {type: 'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                } );
            }
        }

    }
</script>